import { MenuItem, Select, CircularProgress, Box } from "@material-ui/core"
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown"
import React from "react"
import useStyles from "./styles"
import PropTypes from "prop-types"

// if current user is adesk, gives select to choose gtt or crewmama
//  otherwise, just uses api data
const FromOrganizationSelect = ({
  changeCompanyFn,
  headerInfo,
  working = false,
  selectOptions,
  stateValue,
  setStateValue,
}) => {
  const classes = useStyles()
  const { crewmama_or_gtt } = headerInfo

  const handleChange = e => {
    if (e.target.value !== crewmama_or_gtt) {
      setStateValue(e.target.value)
      changeCompanyFn(e)
    }
  }

  return (
    <Select
      id="company-select"
      variant="outlined"
      value={stateValue}
      disabled={working}
      onChange={handleChange}
      margin="dense"
      className={classes.selectInput}
      IconComponent={iconProps => (
        <Box {...iconProps} width="15%">
          {working ? (
            <CircularProgress
              size={16}
              style={{ alignSelf: "center", mx: "5px", my: "auto" }}
            />
          ) : (
            <ArrowDropDownIcon />
          )}
        </Box>
      )}
      SelectDisplayProps={{
        style: {
          display: "flex",
          width: "85%",
        },
      }}
    >
      {selectOptions.map((x, i) => (
        <MenuItem key={i} value={x.value}>
          {x.name}
        </MenuItem>
      ))}
    </Select>
  )
}

FromOrganizationSelect.propTypes = {
  headerInfo: PropTypes.object.isRequired,
  changeCompanyFn: PropTypes.func.isRequired,
  working: PropTypes.bool,
  selectOptions: PropTypes.array.isRequired,
  stateValue: PropTypes.string.isRequired,
  setStateValue: PropTypes.func.isRequired,
}

export default FromOrganizationSelect
